<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M7.714 4a.857.857 0 00-.857.857v2h-2a.857.857 0 000 1.714h2v15.143c0 .79.64 1.429 1.429 1.429h15.143v2a.857.857 0 001.714 0v-2h2a.857.857 0 000-1.714H8.57V4.857A.857.857 0 007.714 4z"/><path d="M21.714 21.714v-3.647l-3.018-3.018a1.429 1.429 0 00-2.02 0l-6.39 6.39v.275h11.428z"/><path d="M10.286 8.571h13.143v13.143h1.714V8.286c0-.79-.64-1.429-1.429-1.429H10.286v1.714z"/><path d="M12.857 15.429a2.572 2.572 0 100-5.143 2.572 2.572 0 000 5.143z"/></svg>
</template>

<script>
export default {
  name: 'mediaImageExpandedFilled'
}
</script>
